import './info.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { useState } from 'react';
import categoryData from '../../data/category.json';
import infoData from '../../data/info.json';

// 情報データの型定義
interface InfoItem {
  info_id: string;
  info_time: string;
  info_status: string;
  info_category: string;
  info_url: string;
  info_title: string;
}

export const Info = () => {
  // データのソート（新しい順）
  const sortedInfoData: InfoItem[] = infoData.sort((a: InfoItem, b: InfoItem) => {
    return new Date(b.info_time).getTime() - new Date(a.info_time).getTime();
  });

  // カテゴリ検索
  const [filteredInfoData, setFilteredInfoData] = useState<InfoItem[]>(sortedInfoData.filter(item => item.info_status === "new"));
  const [selectedCategory, setSelectedCategory] = useState<string>('新着'); 
  const [showCategory, setShowCategory] = useState<number>(0);

  // カテゴリリストの開閉
  const openCategorytList = () => { showCategory === 1 ? setShowCategory(0) : setShowCategory(1); };

  // カテゴリ選択の処理
  const selectCategory = (category_name: string) => {
    setSelectedCategory(category_name);
    setShowCategory(0);
    if (category_name === "すべて") {
      const filteredData = sortedInfoData.filter(item => 
        (item.info_status === "new" || item.info_status === "active")
      );
      setFilteredInfoData(filteredData);
    } else if (category_name === "新着") {
      const filteredData = sortedInfoData.filter(item => 
        item.info_status === "new"
      );
      setFilteredInfoData(filteredData);
    } else {
      const filteredData = sortedInfoData.filter(item => 
        (item.info_status === "new" || item.info_status === "active") && item.info_category === category_name
      );
      setFilteredInfoData(filteredData);
    }
  };

  // 年ごとにデータをグループ化する関数
  const groupByYear = (data: InfoItem[]): { [year: string]: InfoItem[] } => {
    return data.reduce((acc: { [year: string]: InfoItem[] }, current: InfoItem) => {
      const year = new Date(current.info_time).getFullYear().toString(); // 年を文字列に変換
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year].push(current);
      return acc;
    }, {});
  };


  // グループ化されたデータ
  const groupedInfoData = groupByYear(filteredInfoData);

  return (
    <>
      <Header />
      <main>
        <div className="contents-title-box">
          <h3 className='f-color-base'>{selectedCategory}のお知らせ</h3>
        </div>

        <div className='info-container'>
          {/* カテゴリリスト */}
          <div className="info-search-box">
            <div className="category-list">
              <div className='selected-category bg-color-main f-color-sub' onClick={openCategorytList}>
                <p>カテゴリを選ぶ</p>
              </div>
              {showCategory === 1 ? (
                <ul>
                  {categoryData.map(item => (
                    <li
                      key={item.category_id}
                      onClick={() => selectCategory(item.category_name)}
                      className='bg-color-sub f-color-sub'
                    >
                      <div className='category-list-item'><p>{item.category_name}</p></div>
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </div>

          {/* 検索結果（年ごとに表示） */}
          <div className='info-list-box'>
            {Object.keys(groupedInfoData).length > 0 ? (
              Object.keys(groupedInfoData).sort((a, b) => parseInt(b) - parseInt(a)).map((year) => (
                <div className='info-year-section' key={year}>
                  <h4 className='f-color-base'>{year}年</h4>
                    {groupedInfoData[year].map(item => (
                      <div key={item.info_id} className='info-list-item'>
                        <div className='info-list-item-base'>
                          {item.info_category === 'メディア掲載' ?
                            <div className='info-list-item-category bg-color-impact f-color-sub' onClick={() => selectCategory(item.info_category)}><p>{item.info_category}</p></div>
                            :
                            <div className='info-list-item-category bg-color-main f-color-sub' onClick={() => selectCategory(item.info_category)}><p>{item.info_category}</p></div>
                          }
                          {item.info_url !== '' ? 
                            <a href={`pdf/${item.info_url}`} target="_blank" rel="noopener noreferrer"><div className='info-list-item-pdf bg-color-sub f-color-sub'><p>PDF</p></div></a>
                            : <div className='info-list-item-pdf'></div>
                          }
                          <p>{item.info_time}</p>
                        </div>
                        <a href={`pdf/${item.info_url}`} target="_blank" rel="noopener noreferrer"><p className='f-color-base'>{item.info_title}</p></a>
                      </div>
                    ))}
                </div>
              ))
            ) : (
              <div>
                <p>データがありません</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};
